import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2da47ddb"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "px-2" }, "Hoolduskava", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "px-2 text-textDark text-justify mt-3" }, "Pärast kohtuotsuse jõustumist selgitab ametnik välja Teie seaduserikkumise põhipõhjused, samuti muud probleemid, mis on takistanud seaduskuulekalt elamist. Arvestades ka kohtuotsusega pandud kontrollnõudeid ja kohustusi ning koostöös Teiega koostab ta kriminaalhoolduse läbiviimise kava – hoolduskava. Hoolduskavas on kirjeldatud erinevad tegevused kogu kriminaalhoolduse perioodiks. Lisaks hoolduskavas plaanitud tegevuste läbiviimisele saame registreerimise ajal vestelda ja arutleda muudel Teie jaoks olulistel ning vajalikel teemadel. ", -1))
const _hoisted_3 = { class: "sisu" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Tähtaeg:")
], -1))
const _hoisted_6 = { class: "sisu" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Tegevuse eesmärk:")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VoHoiatus = _resolveComponent("VoHoiatus")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_KRHPPaigutus = _resolveComponent("KRHPPaigutus")!

  return (_openBlock(), _createBlock(_component_KRHPPaigutus, null, {
    pais: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_VoHoiatus, { class: "ma-2" }),
              _hoisted_1,
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { class: "px-5" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_data_table, {
                class: "mt-4 rounded elevation-3",
                expanded: _ctx.tabel.laiendatud,
                "onUpdate:expanded": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabel.laiendatud) = $event)),
                headers: _ctx.tabel.paised,
                items: _ctx.tabel.elemendid,
                "items-per-page": _ctx.tabel.lehePikkus,
                loading: _ctx.tabel.laeb,
                "show-expand": "",
                "fixed-header": "",
                "single-expand": "",
                "item-key": "id"
              }, {
                "expanded-row": _withCtx(({ item }) => [
                  _createElementVNode("tr", _hoisted_3, [
                    _hoisted_4,
                    _hoisted_5,
                    _createElementVNode("td", null, _toDisplayString(_ctx.formateeriKuupaev(item.aeg)), 1)
                  ]),
                  _createElementVNode("tr", _hoisted_6, [
                    _hoisted_7,
                    _hoisted_8,
                    _createElementVNode("td", null, _toDisplayString(item.tulemus), 1)
                  ])
                ]),
                _: 1
              }, 8, ["expanded", "headers", "items", "items-per-page", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}